import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NbButtonModule, NbCardModule, NbCheckboxModule, NbInputModule, NbTabsetModule } from '@nebular/theme';
import { TranslateModule } from '@ngx-translate/core';
import { ThemeModule } from '../../@theme/theme.module';
import { KontoComponent } from './konto.component';
import { KontoPodgladComponent } from './podglad/konto-podglad.component';
import { ZmianaHaslaComponent } from './zmiana-hasla/zmiana-hasla.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NbButtonModule,
    NbCardModule,
    NbCheckboxModule,
    NbInputModule,
    NbTabsetModule,
    ReactiveFormsModule,
    ThemeModule,
    TranslateModule,
  ],
  exports: [
    KontoComponent,
    ZmianaHaslaComponent,
  ],
  declarations: [
    KontoComponent,
    KontoPodgladComponent,
    ZmianaHaslaComponent,
  ],
})
export class KontoModule { }
